/**
 * Voice input state machine for AI Coach / voice-test.
 *
 * IDLE → LOADING → LISTENING → PROCESSING → COMPLETED → IDLE
 * Error states: PERMISSION_DENIED, MODEL_DOWNLOAD_ERROR, MODEL_LOAD_ERROR,
 * UNSUPPORTED_BROWSER, OUT_OF_MEMORY, TRANSCRIPTION_ERROR
 */

export const VoiceState = Object.freeze({
  IDLE: "IDLE",
  LOADING: "LOADING",
  LISTENING: "LISTENING",
  PROCESSING: "PROCESSING",
  COMPLETED: "COMPLETED",
  PERMISSION_DENIED: "PERMISSION_DENIED",
  NO_MICROPHONE: "NO_MICROPHONE",
  MODEL_DOWNLOAD_ERROR: "MODEL_DOWNLOAD_ERROR",
  MODEL_LOAD_ERROR: "MODEL_LOAD_ERROR",
  UNSUPPORTED_BROWSER: "UNSUPPORTED_BROWSER",
  OUT_OF_MEMORY: "OUT_OF_MEMORY",
  TRANSCRIPTION_ERROR: "TRANSCRIPTION_ERROR",
});

export const ERROR_STATES = new Set([
  VoiceState.PERMISSION_DENIED,
  VoiceState.NO_MICROPHONE,
  VoiceState.MODEL_DOWNLOAD_ERROR,
  VoiceState.MODEL_LOAD_ERROR,
  VoiceState.UNSUPPORTED_BROWSER,
  VoiceState.OUT_OF_MEMORY,
  VoiceState.TRANSCRIPTION_ERROR,
]);

export function isErrorState(state) {
  return ERROR_STATES.has(state);
}

export function isRecordingState(state) {
  return state === VoiceState.LISTENING;
}

export function canStartListening(state) {
  return (
    state === VoiceState.IDLE ||
    state === VoiceState.COMPLETED ||
    isErrorState(state)
  );
}
